import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { IconButton, SvgIcon, StickyScrollableContainer, Button } from "@adsk/bim360-matrix-react-components";
import T from "i18n-react";

const Drawer = ({ title, children, isOpen, closeDrawer, isFiltered, resetFilters }) => {

  const drawerClassName = cx('Drawer', {
    'Drawer--open': isOpen,
  });

  return (
    <div className={drawerClassName}>
      <StickyScrollableContainer>
        <StickyScrollableContainer.Header className="Drawer__header">
          <div className="Drawer__title">{title}</div>
          {isFiltered && (
            <Button styleType={Button.StyleType.INLINE_LINK} className="FilterPanel__reset" onClick={resetFilters}>
              {T.translate('navigation.resetAll')}
            </Button>
          )}
          <IconButton onClick={closeDrawer} className="Drawer__close-icon">
            <SvgIcon svgId="cancel-input" />
          </IconButton>
        </StickyScrollableContainer.Header>
        <StickyScrollableContainer.Content className="Drawer__content">
          {children}
        </StickyScrollableContainer.Content>
      </StickyScrollableContainer>
    </div>
  );
};

Drawer.displayName = 'Drawer';

Drawer.propTypes = {
  closeDrawer: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isFiltered: PropTypes.bool,
  resetFilters: PropTypes.func,
};

export default Drawer;
